import axios, { AxiosInstance } from 'axios';

export type CatalogServiceSettings = {
  baseURL: string;
  locale: string;
};

const createInstance = (settings: CatalogServiceSettings): AxiosInstance => {
  const headers = {};
  if (settings.locale) {
    headers[`Accept-Language`] = settings.locale;
  }
  return axios.create({
    baseURL: settings.baseURL,
    headers,
  });
};

// ------------------------------------------------------------------------------------------------
// Tech Debt: this method is unlikely to be efficient, therefore try to avoid using where possible.
// TODO:// work with Data team and Catalog Service team to come up with a consistent approach to "Special" course pages
// It is here temporarily in order to support "Special" course pages e.g. international-direct, masters-international-direct, direct-entry, integrated-masters-program
// Where the data format is inconsistent and not filterable by programId
export const getBrandProgramsAsync = async (
  brandId: string,
  settings: CatalogServiceSettings,
  includePrerelease: boolean = false,
): Promise<any> =>
  createInstance(settings).get(
    `/brands/${brandId}/Programs?includePrerelease=${includePrerelease}`,
  );
//-------------------------------------------------------------------------------------------------

// To get Direct Entry Waiver Programs
// Not a BEST method as there should be a consolidated API for this
export const getBrandDewProgramsAsync = async (
  brandId: string,
  settings: CatalogServiceSettings,
  includePrerelease: boolean = false,
): Promise<any> =>
  createInstance(settings).get(
    `/brands/${brandId}/dew-programs?includePrerelease=${includePrerelease}`,
  );

export const getBrandProgramAsync = async (
  brandId: string,
  programId: string,
  settings: CatalogServiceSettings,
): Promise<any> => createInstance(settings).get(`/brands/${brandId}/Programs/${programId}`);

export const getBrandProgramInstancesAsync = async (
  brandId: string,
  programId: string,
  settings: CatalogServiceSettings,
  includePrerelease: boolean = false,
): Promise<any> =>
  createInstance(settings).get(
    `/brands/${brandId}/Programs/${programId}/instances?includePrerelease=${includePrerelease}`,
  );

export const getBrandCoursesData = async (
  brandId: string,
  settings: CatalogServiceSettings,
  includePrerelease: boolean = false,
): Promise<any> =>
  createInstance(settings).get(
    `/brands/${brandId}/Programs?includePrerelease=${includePrerelease}`,
  );

export const getModulesData = async (
  brandId: string,
  programId: string,
  instanceId: string,
  settings: CatalogServiceSettings,
): Promise<any> =>
  createInstance(settings).get(
    `/brands/${brandId}/Programs/${programId}/instances/${instanceId}/modules`,
  );

export const getRegionalQualifications = async (
  brandId: string,
  programId: string,
  instanceId: string,
  settings: CatalogServiceSettings,
): Promise<any> =>
  createInstance(settings).get(
    `/brands/${brandId}/Programs/${programId}/instances/${instanceId}/regional-qualifications`,
  );
